import { render, staticRenderFns } from "./componentes.vue?vue&type=template&id=21b31b41&scoped=true&"
import script from "./componentes.vue?vue&type=script&lang=js&"
export * from "./componentes.vue?vue&type=script&lang=js&"
import style0 from "./componentes.vue?vue&type=style&index=0&id=21b31b41&lang=scss&scoped=true&"
import style1 from "./componentes.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b31b41",
  null
  
)

export default component.exports